import { h } from 'preact';
import { ListEntry } from '../entries/ListEntry';

const TASK_TYPES = ['epx:UserTask', 'epx:ServiceTask', 'epx:ScriptTask'];

const COLUMNS = [
  { key: 'name', label: 'Name' },
  { key: 'outerType', label: 'Type' },
  { key: 'outerId', label: 'ID' },
];

export class PerformerPropertiesProvider {
  constructor(lf, i18n) {
    this._lf = lf;
    this._i18n = i18n;
  }

  isApplicable(elementType) {
    return TASK_TYPES.includes(elementType);
  }

  getGroups(element) {
    const { lf, i18n } = { lf: this._lf, i18n: this._i18n };
    const props = element.properties || {};
    const id = element.id;

    const updatePerformers = (performers) => {
      lf.setProperties(id, { performers });
      lf.emit('node:properties-change', { id, properties: { performers } });
    };

    const performers = props.performers || [];

    return [
      {
        id: 'performers',
        label: i18n.performers || 'Performers',
        entries: [
          {
            id: 'performersList',
            component: () => (
              <ListEntry
                id="epx-performers"
                label=""
                items={performers}
                columns={COLUMNS}
                onAdd={() => updatePerformers([...performers, { name: '', outerType: 'user', outerId: '' }])}
                onRemove={(idx) => {
                  const updated = performers.filter((_, i) => i !== idx);
                  updatePerformers(updated);
                }}
                onChange={(idx, key, value) => {
                  const updated = performers.map((p, i) => i === idx ? { ...p, [key]: value } : p);
                  updatePerformers(updated);
                }}
              />
            ),
          },
        ],
      },
    ];
  }
}
